/**
 * Where signing in goes back to: a page opened signed out (a doc's link from
 * a text, say) is carried to `/login` as `?next=`, and Sign in returns to it.
 * Only a page of the app's own, never another site, nor the sign-in pages.
 */
import { HOME } from "../../app/home";

const OWN = "https://crew.invalid";

/** `next` if it's one of the app's own pages, else null. */
function ownPage(next: string | null): string | null {
  if (!next?.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return null;
  const url = new URL(next, OWN);
  if (url.origin !== OWN || /^\/(login|signup)(\/|$)/.test(url.pathname)) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

/** A guard's redirect `to` from `at`: to sign-in, it takes the page along. */
export function redirectFrom(
  to: string,
  at: { pathname: string; search: string; hash?: string },
): string {
  return to === "/login" ? loginPath(at) : to;
}

/** The sign-in page for someone signed out at `at`; home, the default, needs no `next`. */
function loginPath(at: { pathname: string; search: string; hash?: string }): string {
  const next = ownPage(`${at.pathname}${at.search}${at.hash ?? ""}`);
  return next && next !== HOME ? `/login?next=${encodeURIComponent(next)}` : "/login";
}

/** Where to go once signed in, from the sign-in page's `search`: its `next`, else `fallback`. */
export function afterSignIn(search: string, fallback: string): string {
  return ownPage(new URLSearchParams(search).get("next")) ?? fallback;
}
